<template>
  <div>
    <div class="center-block-date">
      <DatePicker v-model="queryModel.startDate" type="month" size="small" :clearable="false" style="width: 100px"
        :options="dateOptions" @on-change="handleChangeDate"></DatePicker>
      <span class="m-l-5 m-r-5">至</span>
      <DatePicker v-model="queryModel.endDate"  type="month" size="small" :clearable="false" style="width: 100px"
        :options="dateOptions" @on-change="handleChangeDate"></DatePicker>
    </div>

    <!-- 显示地铁线路图 -->
    <SvgLine v-if="showMapType===1" ref="svgline" @map-finished="handleMapLoadFinished" @on-click-station="handleClickStation"/>
    <GeoMap v-else ref="geoMap" @map-finished="handleMapLoadFinished"/>

    <!-- 显示运维上刊情况 -->
    <SvgStationDemand ref="svgStationDemand" :actionDate="gbId"/>
  </div>
</template>

<script>
import SvgLine from '@/components/svg/SvgLine'
import GeoMap from '@/components/map/GeoMap'
import SvgStationDemand from '@/components/svg/SvgStationDemand'

import { lastMonthDate, ParseDate } from '@/utils/dateFormat'
import { getCompanyDateConfig } from '@/api/dw/time'
import { listAssetFinishStationByDate } from '@/api/dw/maintain'
import { listCompanyAssets } from '@/api/dw/datav'

export default {
  components: {
    SvgLine, GeoMap, SvgStationDemand
  },
  data () {
    return {
      showMapType: this.$store.getters.token.publisherSetting.mediaType,
      publisherId: this.$store.getters.token.userInfo.publisherId,
      loginCompanyId: this.$store.getters.token.userInfo.companyId,
      mapFinished: false,
      dateOptions: {}, // 禁用时间项

      queryModel: {
        endDate: '',
        startDate: ''
      }
    }
  },
  created () {
    this.queryModel.startDate = this.searchSchedule.startDate
    this.queryModel.endDate = this.searchSchedule.endDate
    this.initPageData()
  },
  methods: {
    initPageData () {
      const postData = { companyId: this.loginCompanyId }
      getCompanyDateConfig(postData).then(res => {
        this.dateOptions = {
          disabledDate (date) {
            return (date && date.valueOf() < new Date(res.startDate).valueOf() - 86400000) ||
            (date && date.valueOf() > new Date(res.endDate).valueOf())
          }
        }
      })
    },
    handleChangeDate () {
      const curEndDate = new Date(this.queryModel.endDate)
      const formatEndDate = lastMonthDate(curEndDate.getFullYear(), curEndDate.getMonth() + 1)

      const schedule = {
        startDate: ParseDate(this.queryModel.startDate),
        endDate: ParseDate(formatEndDate)
      }

      this.$store.commit('set_situation_companyId', (this.loginCompanyId === this.publisherId) ? '0' : this.loginCompanyId)
      this.$store.commit('set_situation_assetId', '0')

      this.$store.commit('set_situation_searchSchedule', schedule)
    },
    handleMapLoadFinished (val) {
      this.mapFinished = val
      if (val) {
        // 执行线路隐藏操作
        listCompanyAssets({ publisherId: this.publisherId }).then(res => {
          const assetIds = []
          let relateIds = []
          res.forEach(item => {
            relateIds = item.relateIds.split(',').map(x => parseInt(x))

            relateIds.forEach(element => {
              if (!assetIds.includes(element)) {
                assetIds.push(element)
              }
            })
          })
          this.$refs.svgline.hideOtherAsset(assetIds)
        })
      }
    },
    loadAssetFinishStationByDate () {
      const queryModel = {
        assetId: this.assetId,
        workDate: this.gbId,
        companyId: this.companyId,
        publisherId: this.publisherId,
        supplierId: null
      }

      listAssetFinishStationByDate(queryModel).then(res => {
        const formatStations = res.map(x => {
          return {
            quantity: x.value,
            stationId: x.id,
            stationName: x.name
          }
        })

        if (this.showMapType === 1) {
          this.$refs.svgline.loadResourceStations(formatStations)
          // 获取中心站点， 并执行居中处理
          let centerIndex = 0
          if (formatStations.length > 1) {
            centerIndex = parseInt(formatStations.length / 2)
          }
          this.$refs.svgline.handleMapGetCenterByStation(formatStations[centerIndex].stationId)
        } else {
          this.$refs.geoMap.loadResourceStations(formatStations)
        }
      })
    },
    handleClickStation (stationId) { // 地图点击站点事件
      this.$refs.svgStationDemand.handleShowStationDemand(stationId)
    }
  },
  computed: {
    searchSchedule () {
      return this.$store.state.situationWeb.searchSchedule
    },
    assetId () {
      return this.$store.state.situationWeb.assetId
    },
    companyId () {
      return this.$store.state.situationWeb.companyId
    },
    gbId () {
      return this.$store.state.situationWeb.gbId
    }
  },
  watch: {
    gbId (val) {
      if (val) {
        // 开始加载上刊点位信息
        this.loadAssetFinishStationByDate(val)
      } else {
        if (this.showMapType === 1) {
          this.$refs.svgline.loadResourceStations([])
        } else {
          this.$refs.geoMap.loadResourceStations([])
        }
      }
    }
  }
}
</script>

<style>

</style>
